module.exports = __webpack_public_path__ + "img/sh2help.fee23f29.png";